import { render, staticRenderFns } from "./nice-tree-demo.vue?vue&type=template&id=6841bcb9&scoped=true"
import script from "./nice-tree-demo.vue?vue&type=script&lang=js"
export * from "./nice-tree-demo.vue?vue&type=script&lang=js"
import style0 from "./nice-tree-demo.vue?vue&type=style&index=0&id=6841bcb9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6841bcb9",
  null
  
)

export default component.exports